import "lazysizes";

// Mailchimp JSONP submit; delegated so any number of forms on a page work.
document.addEventListener("submit", function (event) {
    const form = event.target.closest && event.target.closest(".js-mailchimp-form");
    if (!form) return;

    event.preventDefault();

    const errorResponse = form.querySelector("[data-mailchimp-error]");
    const successResponse = form.querySelector("[data-mailchimp-success]");
    const submitButton = form.querySelector('[type="submit"]');
    const callbackName = "mailchimpCallback" + Date.now() + Math.random().toString(36).slice(2);

    const endpoint = new URL(form.action);
    endpoint.pathname = endpoint.pathname.replace("/post", "/post-json");
    new FormData(form).forEach((value, key) => endpoint.searchParams.append(key, value));
    endpoint.searchParams.set("c", callbackName);

    errorResponse.style.display = "none";
    successResponse.style.display = "none";
    submitButton.disabled = true;

    const script = document.createElement("script");

    const showResponse = (el, message) => {
        el.textContent = message;
        el.style.display = "block";
    };

    const cleanUp = () => {
        submitButton.disabled = false;
        script.remove();
        delete window[callbackName];
    };

    window[callbackName] = function (result) {
        const message = new DOMParser().parseFromString(result.msg || "", "text/html").body.textContent;

        if (result.result === "success") {
            form.reset();
            showResponse(successResponse, message);
        } else {
            showResponse(errorResponse, message);
        }

        cleanUp();
    };

    script.onerror = function () {
        showResponse(errorResponse, "Unable to submit your email address. Please try again.");
        cleanUp();
    };

    script.src = endpoint.toString();
    document.head.appendChild(script);
});

document.addEventListener("DOMContentLoaded", function () {
    const navBurger = document.querySelector(".nav-burger");
    const header = document.querySelector(".ftwrth-header");

    if (navBurger && header) {
        navBurger.addEventListener("click", function () {
            header.classList.toggle("nav-open");
            document.body.classList.toggle("scroll-locked");
        });
    }

    function throttle(fn, wait) {
        let last = 0;
        return function (...args) {
            const now = Date.now();
            if (now - last >= wait) {
                last = now;
                fn.apply(this, args);
            }
        };
    }

    const onResize = throttle(() => {
        if (window.innerWidth > 960 && header && header.classList.contains("nav-open")) {
            header.classList.remove("nav-open");
            document.body.classList.remove("scroll-locked");
        }
    }, 150);

    window.addEventListener("resize", onResize);

    // Run once on load to ensure correct state
    onResize();
});
